import axios from 'axios';
import BlumarConfig from '../blumar-config';
import store from '../store/store';

export default function executeInterceptor() {
  axios.defaults.baseURL = BlumarConfig.baseUrl;
  axios.interceptors.request.use((request) => {
    // show loader, store instance
    store.dispatch('showLoading', true);
    return request;
  }, error => {
    store.dispatch('showLoading', false);
    return Promise.reject(error);
  });

  axios.interceptors.response.use(response => {
    store.dispatch('showLoading', false);
    return response;
  }, error => {
    store.dispatch('showLoading', false);
    return Promise.reject(error);
  });
};



// WEBPACK FOOTER //
// ./src/services/HttpHelper.js